import { AllieLoading } from "../../../components/ProgressIndicators/Loading";
import { DownloadFileSpinnerProps } from "./DownloadFileSpinner.types";

export const AllieDownloadFileSpinner: React.FC<DownloadFileSpinnerProps> = ({
  isOpen,
  message,
}) => (
  <AllieLoading
    isOpen={isOpen}
    message={message}
    spinner='dots'
  />
);
